module.exports = __webpack_public_path__ + "img/team1.0cf341b3.jpg";